import Vue from 'vue';
import { HTTP_GET, HTTP_POST, HTTP_PUT } from "../const";
import {
  ADD_ACCOUNT,
  ADD_ACCOUNT_WITHDRAW,
  EDIT_ACCOUNT, LOAD_ACCOUNT_PAYINS, LOAD_ACCOUNT_PAYOUTS,
  LOAD_ACCOUNTS_LIST,
  LOAD_ACCOUNTS_NAMES, REQUEST_EXTERNAL_WALLET,
  RESET_ACCOUNTS
} from "../const/accounts";

export default {
  namespaced: true,
  state: {
    accounts: {
      list: [],
      pagination: {},
    },
    payouts: {
      list: [],
      pagination: {},
    },
    payins: {
      list: [],
      pagination: {},
    },
    names: [],
  },
  getters: {
    accounts: state => state.accounts,
    names: state => state.names,
    payouts: state => state.payouts,
    payins: state => state.payins,
  },
  actions: {
    [LOAD_ACCOUNTS_LIST]: async ({ dispatch, commit }, { params }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_ACCOUNTS_LIST,
        namespace: 'accounts',
        params,
      }, { root: true });
    },
    [LOAD_ACCOUNTS_NAMES]: async ({ dispatch, commit }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_ACCOUNTS_NAMES,
        namespace: 'accounts',
      }, { root: true });
    },
    [EDIT_ACCOUNT]: async ({ dispatch, commit }, { name, body }) => {
      const request = await dispatch(HTTP_PUT, {
        method: EDIT_ACCOUNT,
        namespace: 'accounts',
        body,
        replace: { name },
        no_commit: true,
      }, { root: true });
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [ADD_ACCOUNT]: async ({ dispatch, commit }, body) => {
      const request = await dispatch(HTTP_POST, {
        method: ADD_ACCOUNT,
        namespace: 'accounts',
        body,
        no_commit: true,
      }, { root: true });
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [ADD_ACCOUNT_WITHDRAW]: async ({ dispatch, commit }, { name, amount, wallet, direct }) => {
      const request = await dispatch(HTTP_POST, {
        method: ADD_ACCOUNT_WITHDRAW,
        namespace: 'accounts',
        replace: { name },
        body: { amount, wallet, direct },
        no_commit: true,
      }, { root: true });
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [REQUEST_EXTERNAL_WALLET]: async ({ dispatch, commit }, source) => {
      const request = await dispatch(HTTP_POST, {
        method: REQUEST_EXTERNAL_WALLET,
        namespace: 'accounts',
        body: { source },
        no_commit: true,
      }, { root: true });
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [LOAD_ACCOUNT_PAYOUTS]: async ({ dispatch, commit }, { name, params }) => {
      const request = await dispatch(HTTP_GET, {
        method: LOAD_ACCOUNT_PAYOUTS,
        namespace: 'accounts',
        replace: { name },
        params,
      }, { root: true });
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [LOAD_ACCOUNT_PAYINS]: async ({ dispatch, commit }, { name, params }) => {
      const request = await dispatch(HTTP_GET, {
        method: LOAD_ACCOUNT_PAYINS,
        namespace: 'accounts',
        replace: { name },
        params,
      }, { root: true });
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
  },
  mutations: {
    [LOAD_ACCOUNTS_LIST]: (state, { data }) => {
      Vue.set(state.accounts, 'list', data.list);
      Vue.set(state.accounts, 'pagination', data.pagination);
    },
    [LOAD_ACCOUNTS_NAMES]: (state, { data }) => {
      Vue.set(state, 'names', data);
    },
    [LOAD_ACCOUNT_PAYOUTS]: (state, { data }) => {
      Vue.set(state.payouts, 'list', data.list);
      Vue.set(state.payouts, 'pagination', data.pagination);
    },
    [LOAD_ACCOUNT_PAYINS]: (state, { data }) => {
      Vue.set(state.payins, 'list', data.list);
      Vue.set(state.payins, 'pagination', data.pagination);
    },
    [RESET_ACCOUNTS]: (state) => {
      Vue.set(state, 'accounts', {
        list: [],
        pagination: {},
      });
    },
  },
};
